// CustomToolbar.jsx
import React from 'react';
import {
  DefaultToolbar,
  DefaultToolbarContent,
  TldrawUiMenuItem,
  useTools,
  useIsToolSelected,
} from 'tldraw';

export function CustomToolbar(props) {
  const tools = useTools();

  const includedToolIds = ['hand', 'draw', 'eraser'];

  const filteredTools = Object.values(tools).filter(
    (tool) => includedToolIds.includes(tool.id)
  );

  return (
    <DefaultToolbar {...props}>
      {filteredTools.map((tool) => (
        <ToolbarItem key={tool.id} tool={tool} />
      ))}
      
    </DefaultToolbar>
  );
}

function ToolbarItem({ tool }) {
  const isSelected = useIsToolSelected(tool);
  return (
    <TldrawUiMenuItem
      {...tool}
      isSelected={isSelected}
    />
  );
}
